import { SHIPPING_FAQ_ANSWER } from '@/entities/quote';

/**
 * 견적문의 자주 묻는 질문 — 질문 16개는 클라이언트가 정한 목록·순서(2026-10-19)다.
 * 답은 클라이언트가 추후 보내 주기로 했다. 그때까지는 시스템 동작만으로 확실한 것만 적고,
 * 나머지는 ANSWER_PENDING 으로 둔다(답이 오면 이 파일의 문자열만 바꾼다).
 * 근거: CLAUDE.md 서비스 개요, docs/superpowers/specs/2026-10-06-quotes-orders-design.md(§2·§5·§7),
 * docs/superpowers/specs/2026-10-20-shipping-fee-multi-destination-design.md(§6-1 — 배송비 답변, 금액은 적지 않는다).
 */

export interface FaqItem {
  readonly question: string;
  readonly answer: string;
}

/** 아직 답을 받지 못한 질문의 자리 문구 — 답이 오면 지운다. */
export const ANSWER_PENDING =
  '답변을 준비하고 있어요. 급한 문의는 고객센터로 연락 주시면 바로 안내해 드릴게요.';

export const FAQ_ITEMS: readonly FaqItem[] = [
  {
    question: '주문할 상품의 샘플을 미리 받아볼 수 있나요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '최소 구매수량 이하로 제작이 가능한가요?',
    answer:
      '상품마다 최소 주문 수량이 있고, 견적 요청 화면의 수량 칸에 그 수량이 표시돼요. 그보다 적은 수량은 온라인으로 요청할 수 없어요. 소량 제작이 꼭 필요하면 고객센터로 문의해 주세요.',
  },
  {
    question: '배송비와 배송기간에 대해 자세히 알려주세요',
    answer: SHIPPING_FAQ_ANSWER,
  },
  {
    question: '퀵배송으로 상품을 받을 수 있을까요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '자사 디자인 가이드로 주문 제작 가능한가요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '키트 컨셉은 마음에 드는데 상품은 다른 것으로 변경할 수 있을까요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '결제는 어떻게 하나요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '결제 완료 후 결제 수단 변경이 가능한가요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '상품 반품/교환 시 어떻게 해야하나요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '인쇄 방식이 궁금해요',
    answer: ANSWER_PENDING,
  },
  {
    question: '키트 구성품을 자유롭게 구성할 수 있나요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '디자인 서비스도 제공되나요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '제작 기간은 얼마나 걸리나요?',
    answer:
      '상품과 수량, 인쇄 방식에 따라 달라요. 담당자가 발행하는 확정견적서에 제작 착수 시점과 납기가 함께 적히니, 견적을 요청하시면 정확한 일정을 안내받을 수 있어요.',
  },
  {
    question: '로고 파일이 없어도 되나요?',
    answer: ANSWER_PENDING,
  },
  {
    question: '견적서를 받아볼 수 있나요?',
    answer:
      '네. 견적 요청 화면에서 수량을 정하면 수량 구간 단가로 계산한 임시 견적(부가세 포함)을 바로 볼 수 있어요. 담당자가 디자인과 요청 내용을 확인한 뒤 확정견적서를 발행하고, 발행된 견적서는 마이페이지 "내 견적"에서 확인할 수 있어요.',
  },
  {
    question: '스토어에 없는 상품도 만들 수 있나요?',
    answer: ANSWER_PENDING,
  },
];
